
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { RefreshCw, Users, GitBranch } from "lucide-react";

export const ThreadingControls = () => {
  const [isProcessingAllThreads, setIsProcessingAllThreads] = React.useState(false);
  const [activeAccountsCount, setActiveAccountsCount] = React.useState(0);

  const handleProcessAllThreads = async () => {
    try {
      setIsProcessingAllThreads(true);
      console.log('Processing all threads...');
      // TODO: Implement actual thread processing when backend is ready
      setTimeout(() => {
        setIsProcessingAllThreads(false);
      }, 2000);
    } catch (error) {
      console.error("Failed to process threads:", error);
      setIsProcessingAllThreads(false);
    }
  };

  return (
    <Card className="mb-4">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="flex items-center gap-2">
              <GitBranch className="h-5 w-5" />
              Email Threading
            </CardTitle>
            <CardDescription>
              Organize emails into conversation threads for better context
            </CardDescription>
          </div>
          <Button
            onClick={handleProcessAllThreads}
            disabled={isProcessingAllThreads || activeAccountsCount === 0}
            className="gap-2"
          >
            <RefreshCw className={`h-4 w-4 ${isProcessingAllThreads ? 'animate-spin' : ''}`} />
            {isProcessingAllThreads ? 'Processing...' : 'Process Threads'}
          </Button>
        </div>
      </CardHeader>
      
      <Separator />
      
      <CardContent className="pt-4">
        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-2">
            <Users className="h-4 w-4 text-muted-foreground" />
            <span>Email Accounts:</span>
            <Badge variant="secondary">
              {activeAccountsCount} active
            </Badge>
          </div>
          
          {activeAccountsCount === 0 && (
            <Badge variant="destructive">No accounts configured</Badge>
          )}
        </div>
        
        {activeAccountsCount > 0 && (
          <div className="mt-3 text-xs text-muted-foreground">
            Threading will process emails from all active accounts and group them into conversations
          </div>
        )}
      </CardContent>
    </Card>
  );
};
